<mat-toolbar class="filter">
  <h1>Fehler - Seite nicht gefunden</h1>
</mat-toolbar>

<mat-card appearance="outlined" style="margin: 50px;background-color: #ffdddd">
  <mat-card-content>
    <span>Die Seite unter <span class="bold-text">{{url}}</span> konnte nicht gefunden werden</span>
  </mat-card-content>
</mat-card>
